/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import React from 'react';

// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { jsx } from '@emotion/react';
import { expandIconContainerStyle, triggerWrapperStyles, triggerWrapperStylesWithPadding, disableBlueBorderStyles } from '@atlaskit/editor-common/styles';
import { ToolbarButton } from '@atlaskit/editor-common/ui-menu';
import ChevronDownIcon from '@atlaskit/icon/core/migration/chevron-down';
import ItalicIcon from '@atlaskit/icon/core/migration/text-italic--editor-italic';
import { fg } from '@atlaskit/platform-feature-flags';
import { ToolbarType } from './types';
export var DropdownToolbarButton = function DropdownToolbarButton(_ref) {
  var label = _ref.label,
    isReducedSpacing = _ref.isReducedSpacing,
    isDisabled = _ref.isDisabled,
    isSelected = _ref.isSelected,
    ariaExpanded = _ref['aria-expanded'],
    onClick = _ref.onClick,
    onKeyDown = _ref.onKeyDown,
    toolbarType = _ref.toolbarType,
    iconBefore = _ref.iconBefore,
    activeIconName = _ref.activeIconName;
  var reducedSpacing = toolbarType === ToolbarType.FLOATING ? 'compact' : 'none';
  return jsx(ToolbarButton
  // eslint-disable-next-line @atlaskit/design-system/no-unsafe-style-overrides, @atlaskit/ui-styling-standard/no-imported-style-values
  , {
    css: disableBlueBorderStyles,
    testId: 'ak-editor-selection-toolbar-format-text-button',
    spacing: isReducedSpacing ? reducedSpacing : 'default',
    disabled: isDisabled,
    selected: isSelected,
    "aria-label": label,
    "aria-expanded": ariaExpanded,
    "aria-haspopup": true,
    title: label,
    onClick: onClick,
    onKeyDown: onKeyDown,
    iconBefore: jsx("div", {
      css: fg('platform-visual-refresh-icons') ?
      // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values
      triggerWrapperStylesWithPadding :
      // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values
      triggerWrapperStyles,
      "data-testid": activeIconName ? "editor-toolbar__".concat(activeIconName) : undefined
    }, iconBefore ? iconBefore : jsx(ItalicIcon, {
      color: "currentColor",
      spacing: "spacious",
      label: ""
    }), jsx("span", {
      css: expandIconContainerStyle
    }, jsx(ChevronDownIcon, {
      label: "",
      color: "currentColor",
      LEGACY_margin: "0 0 0 -8px",
      size: "small"
    })))
  });
};